module.exports = __webpack_public_path__ + "img/resized-APP-0002-1.cb266990.png";